import React, { useState, useEffect } from "react";
import {
    Button,
    Form,
    Input,
    Select,
    Modal,
    Popconfirm
} from "antd";

import commonLookup from "../../../services/commonLookupService";
import { ContactField } from "@seims/shared";
import util from "../../../utils/functions/custom";
import { recordError } from "../../../utils/logService";

const EditProjectLead = ({
    data,
    visible,
    onCancel,
    onModalSubmit,
}) => {
    const [titles, setTitles] = useState([]);
    const [titleId, setTitleId] = useState(0);
    const [disabled, setDisabled] = useState(true);
    const [contactValue, setContactValue] = useState(data?.contactNumber);
    const { Option } = Select;
    const [form] = Form.useForm();
    const formName = "EditProjectLeadForm";

    useEffect(() => {
        getTitles();
        getUserDetails();
    }, [data]);


    const getUserDetails = () => {
        if (!util.isEmpty(data)) {
            var leadTitle = titles.find((title) => title.key === data.title);
            form.setFieldsValue({
                firstname: data.firstname,
                lastname: data.lastname,
                contactNumber: data.contactNumber,
                email: data.email,
                title: leadTitle !== undefined ? leadTitle : ""
            });

            setContactValue(data.contactNumber);
            setTitleId(data.title);
        }
    }

    const getTitles = async () => {
        try {
            const response = await commonLookup.getTitles();
            if (response) {
                const { data } = response;
                setTitles(data);
            }
        } catch (error) {
            recordError(error);
        }
    };

    const onTitleChange = (selected) => {
        const selectedTitle = titles.find((record) => record.key == selected);
        form.setFieldsValue({ title: selectedTitle });
    };

    const onNameBlur = (e) => {
        const { value, name } = e.target;
        const textValue = util.toPascalText(value);
        form.setFieldsValue({ [name]: textValue });
    };

    const handleContactChange = (value) => {
        if (value === 0 || value.length < 10) {
            form.setFieldsValue({ contactNumber: undefined });
            return;
        }
        form.setFieldsValue({ contactNumber: value });
    };

    const onPopCancel = () => {
        onCancel();
        setDisabled(true);
    };

    const Confirm = () => {
        onCancel();
        form.resetFields();
    };

    const onSubmit = async (values) => {
        try {
            const projectLeadData = {
                title: values.title,
                firstname: values.firstname,
                lastname: values.lastname,
                contactNumber: values.contactNumber,
                email: values.email,
            };
            onModalSubmit(projectLeadData);
        } catch (error) {
            recordError(error);
        }
    };

    return (
        <Modal
            title="Project Lead - Edit"
            open={visible}
            closable={false}
            keyboard={false}
            maskClosable={false}
            onCancel={onCancel}
            width={900}
            footer={[

                <div className="modal-footer-buttons">
                    <Popconfirm
                        key="2"
                        title="Are you sure you want to cancel...you will lose all info entered?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => Confirm()}
                        onCancel={onPopCancel}
                        disabled={disabled}
                    >
                        <Button onMouseUp={() => onPopCancel()} style={{ marginLeft: 10 }}>
                            Cancel
                        </Button>
                    </Popconfirm>
                    <Button
                        type="primary"
                        htmlType="submit"
                        onSubmit={onSubmit}
                        form={formName}
                    >Update</Button>
                </div>,
            ]}
        >
            <Form
                disabled={false}
                labelCol={{
                    span: 4,
                }}
                wrapperCol={{
                    span: 18,
                }}
                form={form}
                name={formName}
                onFinish={onSubmit}
            >
                <Form.Item
                    name="title"
                    label="Title"
                    rules={[{ required: true, message: "Please select title" }]}
                    className="custom-select"
                >
                    <Select onChange={onTitleChange}>
                        {titles.map((title) => (
                            <Option key={title.key}>{title.value}</Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="contactNumber"
                    label="Contact no"
                    rules={[
                        {
                            required: true,
                            message: "Please enter your contact number",
                        },
                    ]}
                >
                    <ContactField
                        contactValue={contactValue}
                        onContactChange={handleContactChange}
                    />
                </Form.Item>
                <Form.Item
                    name="firstname"
                    label="Name"
                    rules={[
                        {
                            pattern: new RegExp("[A-Za-z]"),
                            message: "Provided charaters not allowed"
                        },
                        {
                            required: true,
                            message: "Please enter your name"
                        }
                    ]}
                >
                    <Input name="firstname" onBlur={onNameBlur} />
                </Form.Item>
                <Form.Item
                    name="lastname"
                    label="Surname"
                    rules={[
                        {
                            pattern: new RegExp("[A-Za-z]"),
                            message: "Provided charaters not allowed"
                        },
                        {
                            required: true,
                            message: "Please enter your surname"
                        }
                    ]}
                >
                    <Input name="lastname" onBlur={onNameBlur} />
                </Form.Item>
                <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                        {
                            required: true,
                            message: "Please insert your email",
                        },
                        {
                            type: 'email',
                            message: 'The input is not valid E-mail!',
                        },
                    ]}
                >
                    <Input name="email" disabled />
                </Form.Item>
                <br />
            </Form>
        </Modal>
    )
}

export default EditProjectLead;
